import Logo from "@/assets/home/logo.svg?react";
import type { SourceSystemConfig } from "@/config/sourceSystem";
import { getSavedBrandConfig } from "@/utils/sourceSystemBrand";

interface BrandLogoProps {
  config?: SourceSystemConfig;
  className?: string;
}

export function BrandLogo({ config = getSavedBrandConfig(), className }: BrandLogoProps) {
  if (config.logoUrl) {
    return (
      <img
        src={config.logoUrl}
        alt={config.title}
        className={`${className ?? ""} object-contain`}
      />
    );
  }

  return <Logo className={className} />;
}

interface BrandTitleProps {
  config?: SourceSystemConfig;
  className?: string;
}

export function BrandTitle({ config = getSavedBrandConfig(), className }: BrandTitleProps) {
  return <span className={className}>{config.title}</span>;
}
